import React, { useCallback, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const hasLocationValue = (value: unknown) => {
    if (value === null || value === undefined || value === "") {
        return false;
    }

    return Number.isFinite(Number(value));
};

const ShopLocationBanner = () => {
    const authUser = useSelector((state: any) => state.auth.user);
    const shop = useSelector((state: any) => state.ShopInfo.shop);
    const [dismissed, setDismissed] = useState(false);

    const missingFields = useMemo(() => {
        if (!shop) {
            return [];
        }

        return [
            { key: "latitude", label: "latitude" },
            { key: "longitude", label: "longitude" },
            { key: "altitude", label: "altitude" },
        ].filter((field) => !hasLocationValue(shop?.[field.key]));
    }, [shop]);

    const shouldShow = useMemo(() => {
        if (!authUser || !shop || dismissed) {
            return false;
        }

        return missingFields.length > 0;
    }, [authUser, dismissed, missingFields.length, shop]);

    const dismissBanner = useCallback(() => {
        setDismissed(true);
    }, []);

    if (!shouldShow) {
        return null;
    }

    return (
        <div className="toast pwa-install-alert shadow bg-white show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-body">
                <div className="content d-flex align-items-center mb-2">
                    <i className="ri-map-pin-line fs-4 text-warning me-2" aria-hidden="true"></i>

                    <h6 className="mb-0">Cập nhật vị trí cửa hàng</h6>

                    <button className="btn-close ms-auto" type="button" aria-label="Close" onClick={dismissBanner}></button>
                </div>

                <span className="mb-2 d-block">
                    Shop chưa cập nhật vị trí. Vui lòng bổ sung để khách hàng có thể đặt món qua menu trực tuyến.
                </span>

                <div className="d-flex gap-2">
                    <Link className="btn btn-warning btn-sm" to="/shop/info/edit" onClick={dismissBanner}>
                        Cập nhật ngay
                    </Link>

                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={dismissBanner}>
                        Để sau
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShopLocationBanner;
